import { connect } from "react-redux";
import RenewContract from "./RenewContract";
import { bindActionCreators } from "redux";
import {
  getContractDataForRenewal,
  renewalSaveData,
  fetchInvoiceDetails,
} from "services/redux/brandActivtion/sitesListing/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import { getSearchUser } from "services/redux/tickets/createTicket/action";

const mapStateToProps = (state) => ({
  contractData: state.baSiteListingReducer.contractDataForRenewal,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  renewalSaveResp: state.baSiteListingReducer.renewalSaveResp,
  getInvoiceData: state.baSiteListingReducer.getInvoiceData,
  ownershipUserSuggestions: state.createTicketReducer.searchUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrl,
      getContractDataForRenewal,
      renewalSaveData,
      fetchInvoiceDetails,
      getSearchUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RenewContract);
